<template>
  <div>
    <div v-if="leftText || rightText" class="d-flex justify-content-between">
      <div>
        <span v-if="leftText">{{ leftText || 0 }}</span
        ><span v-if="leftSubText" class="text-muted ms-1"
          >({{ leftSubText || 0 }})</span
        >
      </div>

      <span v-if="rightText" class="text-lighter">{{ rightText || "-" }}</span>
    </div>
    <div class="d-flex justify-content-center">
      <div class="progress flex-grow-1 align-self-center">
        <div
          class="progress-bar p-1"
          :class="getClasses(color, variant)"
          :style="{
            width: Math.round(percentage) + '%',
          }"
        ></div>
      </div>
      <div v-if="endText" class="text-end ms-1 p-1 text-xs text-lighter">
        {{ endText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArgonProgress",
  props: {
    leftText: {
      type: String,
      default: "",
    },
    leftSubText: {
      type: String,
      default: "",
    },
    rightText: {
      type: String,
      default: "",
    },
    endText: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
    variant: {
      type: String,
      default: "fill",
    },
    percentage: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getClasses: (color, variant) => {
      let colorValue;

      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else {
        colorValue = `bg-${color}`;
      }

      return `${colorValue}`;
    },
  },
};
</script>
